import { render } from "./BaseSpinner.vue?vue&type=template&id=2904fb6a&scoped=true&ts=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=ts"
export * from "./BaseSpinner.vue?vue&type=script&lang=ts"

import "./BaseSpinner.vue?vue&type=style&index=0&id=2904fb6a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2904fb6a"]])

export default __exports__